module.exports = __webpack_public_path__ + "img/footer.0c6ae22d.png";